"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminAnnouncementHistoryItemDto = instanceOfAdminAnnouncementHistoryItemDto;
exports.AdminAnnouncementHistoryItemDtoFromJSON = AdminAnnouncementHistoryItemDtoFromJSON;
exports.AdminAnnouncementHistoryItemDtoFromJSONTyped = AdminAnnouncementHistoryItemDtoFromJSONTyped;
exports.AdminAnnouncementHistoryItemDtoToJSON = AdminAnnouncementHistoryItemDtoToJSON;
exports.AdminAnnouncementHistoryItemDtoToJSONTyped = AdminAnnouncementHistoryItemDtoToJSONTyped;
/**
 * Check if a given object implements the AdminAnnouncementHistoryItemDto interface.
 */
function instanceOfAdminAnnouncementHistoryItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function AdminAnnouncementHistoryItemDtoFromJSON(json) {
    return AdminAnnouncementHistoryItemDtoFromJSONTyped(json, false);
}
function AdminAnnouncementHistoryItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'body': json['body'],
        'dedupeKey': json['dedupeKey'] == null ? undefined : json['dedupeKey'],
        'sentAt': json['sentAt'] == null ? undefined : json['sentAt'],
        'createdAt': json['createdAt'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
        'createdByEmail': json['createdByEmail'] == null ? undefined : json['createdByEmail'],
    };
}
function AdminAnnouncementHistoryItemDtoToJSON(json) {
    return AdminAnnouncementHistoryItemDtoToJSONTyped(json, false);
}
function AdminAnnouncementHistoryItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'body': value['body'],
        'dedupeKey': value['dedupeKey'],
        'sentAt': value['sentAt'],
        'createdAt': value['createdAt'],
        'createdBy': value['createdBy'],
        'createdByName': value['createdByName'],
        'createdByEmail': value['createdByEmail'],
    };
}
